import { ComponentPropsWithRef } from 'react';
import { colors } from '@ardoq/design-tokens';
import styled, { css } from 'styled-components';
import { Icon } from './Icon';
import { IconName, IconSize } from './types';
import { DRAG_BUTTON_CLASS_NAME } from './const';

type DragButtonProps = Omit<ComponentPropsWithRef<'button'>, 'children'> & {
  $isDisabled?: boolean;
  iconSize?: IconSize;
};

const UnstyledButton = styled.button<{ $isDisabled?: boolean }>`
  display: inline-flex;
  align-items: center;
  padding: 0;
  border: 0;
  background: transparent;
  font: inherit;
  cursor: grab;
  color: ${colors.grey500};
  &:hover {
    color: ${colors.grey700};
  }
  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      color: ${colors.iconActionDisabled};
      pointer-events: none;
      user-select: none;
    `}
`;

export const DragButton = ({
  iconSize = IconSize.LARGE,
  className,
  ...props
}: DragButtonProps) => (
  <UnstyledButton
    type="button"
    className={[DRAG_BUTTON_CLASS_NAME, className].filter(Boolean).join(' ')}
    {...props}
  >
    <Icon iconName={IconName.DRAG_INDICATOR} iconSize={iconSize} />
  </UnstyledButton>
);
